import { render, staticRenderFns } from "./AppsList.vue?vue&type=template&id=7c5d623a&scoped=true"
import script from "./AppsList.vue?vue&type=script&lang=js"
export * from "./AppsList.vue?vue&type=script&lang=js"
import style0 from "./AppsList.vue?vue&type=style&index=0&id=7c5d623a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d623a",
  null
  
)

export default component.exports